export async function fetchDataStoreMaster(token, setIsLoading, setFilteredRows, selectedJenisOutlet = 'all', selectedTipeSurvey = 'all', selectedTipeJalan = 'all', selectedTipeLokasi = 'all') {
    setFilteredRows([])
    setIsLoading(true);

    // Create an empty URLSearchParams object
    const queryParams = new URLSearchParams();

    if (selectedJenisOutlet && selectedJenisOutlet !== 'all') {
        queryParams.append('jenis_outlet', selectedJenisOutlet);
    }

    if (selectedTipeSurvey && selectedTipeSurvey !== 'all') {
        queryParams.append('tipe_survey', selectedTipeSurvey);
    }

    if (selectedTipeJalan && selectedTipeJalan !== 'all') {
        queryParams.append('tipe_jalan', selectedTipeJalan);
    }

    if (selectedTipeLokasi && selectedTipeLokasi !== 'all') {
        queryParams.append('tipe_lokasi', selectedTipeLokasi);
    }


    // Construct the full URL with query parameters
    const queryString = queryParams.toString();
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/tipe-survey` + (queryString ? `?${queryString}` : '');

    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.ok) {
            const data = await response.json();
            setFilteredRows(data.data); // Initialize filteredRows with the retrieved data
        } else {
            setFilteredRows([])
            // Handle error
        }
    } catch (error) {
        // Handle error
    }

    setIsLoading(false);
}

export async function fetchExportDataStoreMaster(token, setIsLoading, selectedJenisOutlet = 'all', selectedTipeSurvey = 'all', selectedTipeJalan = 'all', selectedTipeLokasi = 'all') {
    setIsLoading(true);

    // Create an empty URLSearchParams object
    const queryParams = new URLSearchParams();

    if (selectedJenisOutlet && selectedJenisOutlet !== 'all') {
        queryParams.append('jenis_outlet', selectedJenisOutlet);
    }

    if (selectedTipeSurvey && selectedTipeSurvey !== 'all') {
        queryParams.append('tipe_survey', selectedTipeSurvey);
    }

    if (selectedTipeJalan && selectedTipeJalan !== 'all') {
        queryParams.append('tipe_jalan', selectedTipeJalan);
    }

    if (selectedTipeLokasi && selectedTipeLokasi !== 'all') {
        queryParams.append('tipe_lokasi', selectedTipeLokasi);
    }


    const queryString = queryParams.toString();
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/store-master/setup/export` + (queryString ? `?${queryString}` : '');
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Result Store Master.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } else if (response.status === 404) {
            alert('data not found')
        } else {
            alert('something went wrong went export data')
        }
    } catch (error) {
        // Handle error
    }

    setIsLoading(false);
}